import Vue from 'vue'
import Router from 'vue-router'
import About from '@/components/settings/about'
import UserGuide from '@/components/settings/userGuide'
import EventManage from '@/components/settings/eventManage'
import Index from '@/components-online/device/allUserDeviceList'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
var router = new Router({
    routes: [
        {
            path: "/test",
            name: 'test',
            component: () => import('../components-online/setting/test')
        },
        {
            path: "/login",
            name: 'login',
            component: () => import('../components-online/login/login')
        },
        {
            path: "/register",
            name: 'register',
            component: () => import('../components-online/login/register')
        },
        {
            path: '/forget',
            name: 'forget',
            component: () => import('../components-online/login/forget')
        },
        {
            path: "/on-deviceList",
            name: 'onDeviceList',
            component: () => import('../components-online/device/deviceList')
        },
        {
            path: '/on-allUserDeviceList',
            name: 'onAllUserDeviceList',
            component:  () => import('../components-online/device/allUserDeviceList.vue')
        },
        {
            path: "/on-curveList",
            name: 'onCurveList',
            component: () => import('../components-online/curve/curveList')
        },
        {
            path: "/on-curveRecommend",
            name: 'onCurveRecommend',
            component: () => import('../components-online/curve/curveRecommend')
        },
        {
            path: "/on-curveCollect",
            name: 'onCurveCollect',
            component: () => import('../components-online/curve/curveCollect')
        },
        {
            path: "/on-allUserCurveList",
            name: 'onAllUserCurveList',
            component: () => import('../components-online/curve/allUserCurveList')
        },
        {
            path: "/on-cupList",
            name: 'onCupList',
            component: () => import('../components-online/cupping/cupList')
        },
        {
            path: "/on-allUserCupList",
            name: 'onAllUserCupList',
            component: () => import('../components-online/cupping/allUserCupList')
        },
        {
            path: '/on-storageStatus',
            name: 'onStorageStatus',
            component: () => import('../components-online/storage/storageStatus')
        },
        {
            path: '/on-recomStatus',
            name: 'onRecomStatus',
            component: () => import('../components-online/storage/recomStatus')
        },
        {
            path: '/on-allUserStorage',
            name: 'onAllUserStorage',
            component: () => import('../components-online/storage/allUserStorage')
        },
        {
            path: '/on-systemSetting',
            name: 'onSystemSetting',
            component: () => import('../components-online/setting/systemSetting')
        },
        {
            path: '/on-accountManagement',
            name: 'onAccountManagement',
            component: () => import('../components-online/setting/accountManagement')
        },
        {
            path: '/on-userManagement',
            name: 'onUserManagement',
            component: () => import('../components-online/setting/userManagement')
        },
		{
            path: '/on-deviceTypeSet',
            name: 'onDeviceTypeSet',
            component: () => import('../components-online/setting/deviceTypeSet')
        },

        // yuanzq add start
        {
            path: "/home",
            name: 'Home',
            component: () => import('../home'),
            children:[
                {
                    path: "/equipment-list",
                    name: 'equipmentList',
                    component: () => import('../components-new/equipment/equipment-list/equipment-list')
                },
                // 设备
                {
                    path: "/deviceList",
                    name: 'deviceList',
                    component: () => import('../components-new/device/deviceList')
                },
                {
                    path: "/allUserDeviceList",
                    name: 'allUserDeviceList',
                    component: () => import('../components-new/device/allUserDeviceList')
                },
                // 曲线
                {
                    path: "/curveList",
                    name: 'curveList',
                    component: () => import('../components-new/curve/curveList')
                },
                {
                    path: "/curveRecommend",
                    name: 'curveRecommend',
                    component: () => import('../components-new/curve/curveRecommend')
                },
                {
                    path: "/curveCollect",
                    name: 'curveCollect',
                    component: () => import('../components-new/curve/curveCollect')
                },
                {
                    path: "/allUserCurveList",
                    name: 'allUserCurveList',
                    component: () => import('../components-new/curve/allUserCurveList')
                },
                // 杯测
                {
                    path: "/cupList",
                    name: 'cupList',
                    component: () => import('../components-new/cupping/cupList')
                },
                //所有用户杯测
                {
                    path: "/allUserCupList",
                    name: 'allUserCupList',
                    component: () => import('../components-new/cupping/allUserCupList')
                },
                // 仓储
                {
                    path: '/storageStatus',
                    name: 'storageStatus',
                    component: () => import('../components-new/storage/storageStatus')
                },
                {
                    path: '/allUserStorage',
                    name: 'allUserStorage',
                    component: () => import('../components-new/storage/allUserStorage')
                },
                // 设置
                {
                    path: '/systemSetting',
                    name: 'systemSetting',
                    component: () => import('../components-new/setting/systemSetting')
                },
                {
                    path: '/userManagement',
                    name: 'userManagement',
                    component: () => import('../components-new/setting/userManagement')
                },
                {
                    path: '/accountManagement',
                    name: 'accountManagement',
                    component: () => import('../components-new/setting/accountManagement')
                },
            ]
        },
        // yuanzq add end
        {
            path:'/event-manage',
            name:'eventManage',
            component: EventManage
        },
        {
            path:'/user-guide',
            name:'userGuide',
            component: UserGuide
        },
        {
            path:'/about',
            name:'about',
            component:About
        },
        {
            path: "/",
            redirect: Index
        }
    ]
})
router.beforeEach((to, from, next) => {
    console.info('跳转：'+to.path)
    if (!localStorage.getItem("userid")) {
        if (to.path != '/login'&&to.path !='/register'&&to.path !='/forget') {
            //console.info(11111)
            //return next()
            return next('/login')
        }
        //console.info(22222)
    }
    //console.info(33333)
    next();
})
export default router;
